<div *ngIf="(loading$ | async)" class="dialog-loading">
    <mat-spinner diameter="36"></mat-spinner>
</div>

<div class="dialog-title">
    <div class="dialog-title-content">
        <div class="full-width map-controls">
            <input class="search-input" #search>

            <button class="action-button" [ngClass]="drawingManagerEnabled ? 'green' : 'gray'" (click)="toggleDrawingMode()">
                <mat-icon>draw</mat-icon>
            </button>

            <button class="action-button blue" *ngIf="locationData?.polyPoints?.length" (click)="drawPolygon(true)">
                <mat-icon>edit</mat-icon>
            </button>

            <mat-checkbox *ngIf="data.allowInexactly" [checked]="locationData?.inexactly"
                          (change)="locationData.inexactly = $event.checked">
                {{ 'Не точно вказані геодані' }}
            </mat-checkbox>

            <button class="action-button red" *ngIf="locationData?.polyPoints?.length" (click)="clearPolygon()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>

        <div (click)="closeDialog()" class="dialog-close">
            <mat-icon>close</mat-icon>
        </div>
    </div>
</div>


<div #mapContainer class="google-map-container"></div>
